import fingerprint from './fingerprint';
import leadSources from './lead-sources';

const modules = [
    fingerprint,
    leadSources
];
export default modules;



// WEBPACK FOOTER //
// ./src/modules/index.js